// Reads the variant's current delayed-shipping-message straight from the
// product's own rendered PDP page (its embedded <script data-section-data>
// JSON) instead of the Shopify Storefront GraphQL API. The metaobject's
// description is already resolved there, so no separate metaobject lookup
// is needed either.
export default async function checkForVariantUpdates(variantId, productUrl) {
  const bareVariantId = String(variantId).includes('/ProductVariant/')
    ? variantId.split('/ProductVariant/')[1]
    : String(variantId);

  try {
    const productPath = productUrl ? new URL(productUrl, window.location.origin).pathname : null;
    if (!productPath) return null;

    const response = await fetch(productPath);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('[data-section="product"] script[data-section-data]');
    const data = script ? JSON.parse(script.textContent) : null;

    const variant = data?.product?.variants?.find((v) => {
      const vBareId = String(v.id).includes('/ProductVariant/') ? v.id.split('/ProductVariant/')[1] : String(v.id);
      return vBareId === bareVariantId;
    });

    return variant ? { delayedShippingMessage: variant.delayedShippingMessage || null } : null;
  } catch (error) {
    return null;
  }
}
